import { DataBean } from "../DataBean";

export class UBLSoftwareDispatcher extends DataBean {

    public async getUBLSoftwareDispatcherByAccount(idAccount: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLSoftwareDispatcherByAccount_Number", [idAccount]);
    }

    public async getUBLEnvironmentTypeConstants(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLEnvironmentTypeConstants_Number", [id]);
    }

}